<template>
    <v-dialog
        v-model="modal"
        :fullscreen="$breakpoint.smAndDown"
        max-width="412"
        data-cy="modal"
        @close="modal = false"
    >
        <v-card class="pt-9 pb-10 px-12">
            <v-btn
                icon="mdi-close"
                variant="text"
                size="small"
                class=""
                data-cy="close"
                style="position: absolute; top: 4px; right: 4px"
                @click="modal = false"
            />
            <v-card-title class="text-h5 text-center">
                {{ $t('trip_assistant') }}
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                    data-cy="trip-assistant-form"
                    class="pb-4"
                    @keyup.native.enter="valid && redirect()"
                >
                    <v-text-field
                        v-model="refNumber"
                        class="mb-2"
                        variant="outlined"
                        density="compact"
                        :label="`${$t('statement_of_account.refNumber')}*`"
                        :rules="[requiredRule('statement_of_account.refNumber')]"
                        data-cy="reservation-number"
                    />
                    <v-text-field
                        v-model="lastName"
                        class="mb-2"
                        variant="outlined"
                        density="compact"
                        :label="`${$t('last_name')}*`"
                        :rules="[requiredRule('last_name')]"
                        data-cy="last-name"
                    />
                </v-form>
                <v-btn
                    variant="flat"
                    color="primary"
                    block
                    data-cy="submit-button"
                    class="mb-5"
                    :disabled="!valid"
                    @click="redirect"
                >
                    {{ $t('retrieve_booking') }}
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    const modal = defineModel<boolean>({
        default: false,
    })

    const valid = ref<boolean>(false)
    const refNumber = ref<string>(null)
    const lastName = ref<string>(null)

    const router = useRouter()
    const redirect = () => {
        modal.value = false
        router.push({name: 'tripAssistant', params: {id: refNumber.value, name: encodeURIComponent(lastName.value)}})
    }
</script>
